import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { GasButtonModule } from '../../forms/gas-button/gas-button.module';
import { GasIconsModule } from '../../utils/gas-icons/gas-icons.module';

import { GasPopoverComponent } from './gas-popover/gas-popover.component';
import { GasPopoverDirective } from './gas-popover/gas-popover.directive';

const COMPONENTS = [
  GasPopoverComponent,
];

const DIRECTIVES = [
  GasPopoverDirective,
];

@NgModule({
  declarations: [
    COMPONENTS,
    DIRECTIVES,
  ],
  exports: [
    COMPONENTS,
    DIRECTIVES,
  ],
  entryComponents: [
    COMPONENTS,
  ],
  imports: [
    CommonModule,
    GasIconsModule,
    GasButtonModule,
  ],
})
export class GasPopupModule { }
